import { EyeOutlined } from '@ant-design/icons';
import { Button, Row, Space, Tooltip, Typography } from 'antd';

import type { ModelDataMigration } from '@app/api/Migration';
import { YClientsImg } from '@app/assets';
import { handleTimestamp } from '@app/utils';

import { StatusTag } from '@pages/DataMigration/components/StatusTag';

const { Text } = Typography;

export const adaptDataToTable = (
  migrationsList: ModelDataMigration[],
  onNavigateToCard: (legalEntityId: number) => void
) =>
  migrationsList.map(
    ({ Login, LegalEntityId, CreateUser, Status, TimeCreated }) => ({
      key: LegalEntityId,
      migration: (
        <Space size="middle" style={{ minWidth: '300px' }}>
          <img
            alt="Логотип YClients"
            src={YClientsImg}
            style={{ height: '25px', width: 'auto' }}
          />
          <Space direction="vertical">
            <Space>
              <Text data-testid="company-name">YClients</Text>
              <Text type="secondary" data-testid="migration-login">
                {Login}
              </Text>
            </Space>
            <Text type="secondary" data-testid="migration-date-time">
              {handleTimestamp(TimeCreated)}
            </Text>
          </Space>
        </Space>
      ),
      user: <span data-testid="migration-initiator">{CreateUser}</span>,
      status: <StatusTag status={Status} />,
      actions: (
        <Row justify="end">
          <Space>
            <Tooltip title="Посмотреть детали">
              <Button
                icon={<EyeOutlined />}
                onClick={() => onNavigateToCard(LegalEntityId)}
                data-testid="migration-details"
              />
            </Tooltip>
          </Space>
        </Row>
      ),
    })
  );
